import { useEffect } from "react"

import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Route, Routes, useNavigate } from "react-router-dom"
import SearchParams from "simplydo/core/searchParams"
import styled from "styled-components"

import actions from "actions"
import { StyledDashboard } from "components/AppOnboarding"
import DownloadAppBanner from "components/home/DownloadAppBanner"

import Enrol from "./Enrol"
import ForgottenPassword from "./ForgottenPassword"
import Login from "./Login"
import RegisterFlow from "./RegisterFlow"
import ResetPassword from "./ResetPassword"

const StyledEntry = styled.div`
  flex: 1 0 auto;
  display: ${({ theme }) => (!theme.sizes.isComputer ? "block" : "flex")};
  width: 100%;
`

function Entry({ user }) {
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      return
    }

    const params = new SearchParams(window.location.search)
    const then = params.get("then") ?? "/"
    const code = params.get("code")
    if (then && (!code || (code && user?.ownerOrganisation?.code === code))) {
      navigate(then)
    }
  }, [user, navigate])

  return (
    <StyledEntry>
      <DownloadAppBanner />
      <Routes>
        <Route
          path="password/forgotten"
          element={<StyledDashboard excludeWelcomeText padded="very" content={<ForgottenPassword />} />}
        />
        <Route
          path="password/reset"
          element={<StyledDashboard excludeWelcomeText padded="very" content={<ResetPassword />} />}
        />
        <Route
          path="enrol"
          element={<StyledDashboard excludeWelcomeText padded="very" scrolling={false} content={<Enrol />} />}
        />
        <Route
          path="register"
          element={<StyledDashboard excludeWelcomeText scrolling={false} padded="very" content={<RegisterFlow />} />}
        />
        <Route
          path="*"
          element={<StyledDashboard backgroundColor="#14435B" excludeWelcomeText padded="very" content={<Login />} />}
        />
      </Routes>
    </StyledEntry>
  )
}

const mapStateToProps = (state) => ({ user: state.user, organisation: state.organisations.urlOrganisation })
const mapDispatchToProps = (dispatch) => ({
  onSelectOrganisation: (org) => dispatch(actions.organisations.receiveUrlOrganisation(org)),
})
const EntryContainer = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Entry))

export default EntryContainer
